import { type MetaFunction } from '@remix-run/node'
import productMedicareAdvantage from './product-medicare-advantage.png'

export const meta: MetaFunction = () => [
	{ title: 'Medicare Advantage Plans' },
	{
		name: 'description',
		content: 'We offer Medicare Advantage Plans.',
	},
]

const MedicarePage = () => {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Medicare Advantage Plans</h1>
			<h3>How does a medicare advantage plan work?</h3>
			<p>
				When you join a medicare advantage plan, you still have medicare. You'll
				get your Part A (Hospital Insurance) and Part B (Medical Insurance)
				coverage from the medicare advantage plan and not original medicare.
			</p>
			<h3>Protect your new card</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you receive your new medicare card, bring it in to our office to
				have it laminated free of charge. You can also bring your old medicare
				card to shred it.
			</p>
			<h2>
				How do you get <em>your</em> Medicare?
			</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				There are different ways that people receive their medicare benefits.
				Here are two popular ways:
			</p>
			<div
				style={{
					display: `grid`,
					gridGap: `20px`,
					gridTemplateColumns: `1fr 1fr`,
				}}
			>
				<div>
					<h3>
						Option 1<br />
						Original Medicare
					</h3>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						Part A - Hospital Insurance
					</p>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						Part B - Medical Insurance
					</p>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						You can add - Part D (Prescription Drug Coverage){' '}
					</p>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						You can also add Medicare Supplement Insurance to help pay your out
						of pocket cost-sharing from original medicare.{' '}
					</p>
				</div>
				<div>
					<h3>
						Option 2<br />
						Medicare Advantage (Part C)
					</h3>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						Part A - Hospital Insurance
					</p>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						Part B - Medical Insurance
					</p>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						Part D (Prescription Drug Coverage)
					</p>
				</div>
			</div>
			<img
				src={productMedicareAdvantage}
				alt="A man kissing a woman on the beach"
				className="rounded-lg object-cover object-center"
			/>
			See also:{' '}
			<a
				href="/products-and-programs/medicare-supplement"
				className="text-blue-600 underline"
			>
				Medicare Supplement
			</a>{' '}
			and{' '}
			<a
				href="/products-and-programs/medicare-part-d-prescription-drug-plans"
				className="text-blue-600 underline"
			>
				Medicare Part D
			</a>
		</main>
	)
}

export default MedicarePage
